<template>
  <b-modal
    :id="`member-checkin${id}`"
    modal-class="modal-style two-footer-btn"
    ref="modal"
  >
    <template>
      <p class="modal-style-title">會員報到</p>
      <div class="modal-style-content">
        <p>
          請確認會員
          <span class="name">{{ memberName }}</span>
          是否報到
        </p>
      </div>
    </template>

    <template v-slot:modal-footer>
      <button
        class="transparent-btn"
        @click="$bvModal.hide(`member-checkin${id}`)"
      >
        取消
      </button>
      <button class="custom-btn" @click="handleCheckIn">
        報到
      </button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: {
    id: {
      required: true,
      type: Number
    },
    memberName: {
      required: true,
      type: String
    }
  },
  methods: {
    routeTo() {
      alert('轉跳頁面');
      //  this.$router.push({ name: '品牌登入頁' });
    },
    handleCheckIn() {
      this.$emit('handleCheckIn', this.id);
    }
  }
};
</script>
